import { useCallback, useMemo, useState } from 'react';
import useSearchParamsConfig from './useSearchParamsConfig';

export default function useCompanyFilters(defaultSearchParams) {
  const filters = useMemo(
    () => ({
      companyIndustries: [],
      companyIsActive: null,
      companyOwners: [],
      companyPractices: [],
      companyBusinessUnits: [],
      companySpendTiers: [],
      companyTypes: [],
    }),
    [],
  );

  const [defaultParams] = useState(defaultSearchParams);

  const searchParamsConfig = useSearchParamsConfig();

  const companySearchParamsConfig = useMemo(
    () => ({
      companyIndustries: searchParamsConfig.companyIndustries,
      companyIsActive: searchParamsConfig.companyIsActive,
      companyOwners: searchParamsConfig.companyOwners,
      companyPractices: searchParamsConfig.companyPractices,
      companyBusinessUnits: searchParamsConfig.companyBusinessUnits,
      companySpendTiers: searchParamsConfig.companySpendTiers,
      companyTypes: searchParamsConfig.companyTypes,
      ...defaultParams,
    }),
    [searchParamsConfig, defaultParams],
  );

  const mapUrlSearchParams = useCallback((filters) => {
    return {
      companyIndustryId: filters.companyIndustries?.map((industry) => industry.id),
      companyIsActive: filters.companyIsActive ?? undefined,
      companyOwnerId: filters.companyOwners?.map((owner) => owner.id),
      companyPracticeId: filters.companyPractices?.map((practice) => practice.id),
      companyBusinessUnitId: filters.companyBusinessUnits?.map((businessUnit) => businessUnit.id),
      companySpendTierId: filters.companySpendTiers?.map((tier) => tier.id),
      companyTypeId: filters.companyTypes?.map((type) => type.id),
    };
  }, []);

  return useMemo(
    () => ({ filters, searchParamsConfig: companySearchParamsConfig, mapUrlSearchParams }),
    [filters, companySearchParamsConfig, mapUrlSearchParams],
  );
}
